export type ErrorCode =
  | 'VALIDATION_ERROR' | 'UNAUTHORIZED' | 'FORBIDDEN'
  | 'NOT_FOUND' | 'CONFLICT' | 'RATE_LIMITED'
  | 'UPSTREAM_ERROR' | 'INTERNAL' | 'NETWORK';

export interface ApiErrorEnvelope {
  error: {
    code: ErrorCode;
    message: string;
    details?: Record<string, unknown>;
    requestId?: string;
  };
}

export class ApiError extends Error {
  constructor(
    public status: number,
    public code: ErrorCode,
    message: string,
    public details?: Record<string, unknown>,
    public requestId?: string,
  ) {
    super(message);
  }
}

export function parseErrorEnvelope(status: number, body: unknown): ApiError {
  if (
    body && typeof body === 'object' && 'error' in body &&
    body.error && typeof body.error === 'object'
  ) {
    const e = (body as ApiErrorEnvelope).error;
    return new ApiError(status, e.code ?? 'INTERNAL', e.message ?? 'unknown', e.details, e.requestId);
  }
  return new ApiError(status, 'INTERNAL', `HTTP ${status}`);
}
